var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEfectivoSeguroAprobado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.55,
    height: 63.9,
    viewBox: "0 0 74.55 63.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "efectivo-seguro-aprobado",
    d: "M13.65,5.992A10.647,10.647,0,0,0,3,16.642V43.267H32.287a2.662,2.662,0,0,0,0-5.325H18.975a10.647,10.647,0,0,0-10.65-10.65V21.967a10.647,10.647,0,0,0,10.65-10.65h31.95a10.647,10.647,0,0,0,10.65,10.65h2.662A2.67,2.67,0,0,0,66.9,19.3V5.992Zm0,31.95H8.325V32.617A5.341,5.341,0,0,1,13.65,37.942Zm-5.325-21.3a5.341,5.341,0,0,1,5.325-5.325A5.341,5.341,0,0,1,8.325,16.642Zm53.25,0a5.341,5.341,0,0,1-5.325-5.325h5.325ZM40.275,35.28c0-4.926,7.135-7.987,18.637-7.987S77.55,30.354,77.55,35.28V48.592c0,12.833-11.715,19.463-17.919,21.193a2.243,2.243,0,0,1-.719.107,3.351,3.351,0,0,1-.719-.107h0c-6.2-1.7-17.919-8.36-17.919-21.193ZM58.912,64.434c2.875-.985,13.312-5.3,13.312-15.842V35.28c-.266-.346-3.887-2.662-13.312-2.662S46.079,34.774,45.6,35.439V48.592C45.6,59.109,56.01,63.449,58.912,64.434Zm-6.1-20.395L56.25,47.5l8.76-8.786L68.79,42.5,56.25,55.009,49.035,47.82ZM26.962,24.63a8.011,8.011,0,0,1,7.987-7.988l.027-.027A8,8,0,0,1,41.9,20.609a2.672,2.672,0,1,1-4.633,2.662,2.669,2.669,0,1,0-3.648,3.648,2.672,2.672,0,0,1-2.662,4.633A8.061,8.061,0,0,1,26.962,24.63Z",
    transform: "translate(-3 -5.992)",
    fill: "#00c1d4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfectivoSeguroAprobado);
export default __webpack_public_path__ + "static/media/efectivo-seguro-aprobado.47ebf01b0a526907e7b2d571c6a2b911.svg";
export { ForwardRef as ReactComponent };